/**
 * view_widgets.js
 *
 * A collection of widgets that are shared across MachineLogic views.
 *
 */
"use strict";
(function () {
  const $ = require('jQuery');
  const widgets = require('./widgets');
  const icons = require('../icons');
  const environment = require('../environment');
  const machinelogic = require('../machinelogic');
  const machine_app_state = require('../machine_app/models/machine_app_state');
  const { PlayerControls } = require('../views/visual_sequence_editor/player_controls/PlayerControls');
  const ReactDOM = require('react-dom');
  const React = require('react');
  const { cleanUpReactElementsByID } = require('./machinelogic_react_components_support');

  function checkboxWidget(pName, pChecked, pOnCheck) {
    const lWidget = widgets.checkbox(undefined, pChecked, pOnCheck).attr('checked', pChecked);

    if(!pName) { return lWidget; }

    const lDiv = widgets.baseWidget(pName).addClass('h_layout');
    lDiv.find('.ml_widget_label')
      .css({
        'font-size': '18px',
        'font-weight': '400',
        'line-height': '1rem'
      });
    lWidget.css('margin-right', '5px');
    lDiv.prepend(lWidget);
    lDiv.checkbox = lWidget;
    return lDiv;
  }

  /**
   * The Document object is used to display the provided widget in the right
   * container specified by the editor function in machinelogic_widgets.js.
   *
   * @param {Object} pObject Data object that is saved on the Document.
   * @param {JQuery} pWidget JQuery widget to show in the container
   * @param {*} pButtons
   */
  function Document(pObject, pWidget, pButtons) {
    this.object = pObject;
    this.widget = pWidget;
    this.tab = $('<li class="ml_editor_tab h_layout"/>').append('<div class="ml_error_icon ' + icons.error + '"/>');
    this.buttons = pButtons || [];

    const lDocument = this;
    const lTabLabel = $('<div class="truncated_text">' + pObject.getName() + '</div>');
    const lTabClose = $("<button type='button' class='ml_close'/>");

    // For some reason, detach() doesn't work on tabs, I have to remove() them. Which means handlers need to be bound again
    this.registerEvents = function() {
      this.tab.click(function() {
        $('.ml_editor').trigger('open_document', lDocument);
      });

      lTabClose.click(function() {
        $('.ml_editor').trigger('close_document', lDocument); // deprecated // Do not know if this is safe to remove yet
      });
    };

    this.tab.setName = function(pName) { lTabLabel.text(pName); };
    this.tab.append(lTabLabel);
    this.tab.append(lTabClose);
  }

  /**
   * Displays the Document object. This object gets opened by the leftPane.
   *
   * @param {Boolean} pNoTab
   * @param {() => JQuery} pGetPlayerWidget Used to retrieve the player widget.
   * @returns
   */
  function documentContainer(pGetPlayerWidget, pMachineAppProps) {
    // UI
    const lEditor = $('<div>').addClass('ml_editor');
    const lDocument =   $('<div>').appendTo(lEditor);
    const lFooter = $('<div>')
      .addClass("ml_footer_pendant")
      .appendTo(lEditor);

    // on Editor init, load helper text page;
    lDocument.addClass('helper_text_editor_document');
    lDocument.append(getHelperText());

    // Reset Editor
    function resetEditor() {
      cleanUpReactElementsByID("playerControls");
      lDocument.empty().removeClass();
      lFooter.empty();
    }


    lEditor.on('open_document', function(pEvent, pDocument) {
      resetEditor();

      lDocument.append(pDocument.widget);

      if (pDocument.object instanceof machinelogic.Sequence) {
        lDocument.addClass('sequence_editor_document');
        lDocument.find('.ui-sortable').addClass('ml_scrollable');
        if (pDocument.object.getApp().mIsMachineApp) {
          lFooter.addClass('machine_app_operate_button_in_ml_page_container').append(
            $('<button>').text('Operate').addClass('machine_app_operate_button_in_ml_page').on('click', function() {
              if (machine_app_state.getInterface()?.redirectMachineAppToAppLauncher) {
                machine_app_state.getInterface().redirectMachineAppToAppLauncher(pDocument.object.getApp().getMachineApp().getName());
              }
            })
          );
        }
        else {
          lFooter.append(pGetPlayerWidget());
        }
      }
      else if (pDocument.object instanceof machinelogic.Application) {
        lDocument.addClass('application_editor_document ml_scrollable');
      }
      // else if (pDocument.object instanceof machinelogic.RobotApp) {
      //   console.warn('TODO');
      // }
      else if (pDocument.object instanceof machinelogic.Controller) {
        lDocument.addClass('controller_editor_document');
      }
      else if (pDocument.object instanceof machinelogic.Config) {
        lDocument.addClass('config_editor_document ml_scrollable');
      }
      else if (pDocument.object instanceof machinelogic.ConfigManager) {
        lDocument.addClass('config_editor_document');
      }
      else if (pDocument.object instanceof machinelogic.ApplicationUI) {
        lDocument.addClass('ui_editor_document');
      }
      else if(pDocument.object && pDocument.object.readOnly) {
        lDocument.css({ 'height': '100%'});
      }
      else {
        console.error('document container: Document Type not supported: ', pDocument.object);
      }

      if (pDocument.buttons !== undefined) {
        const lToolbar = $('.ml_editor_toolbar');
        pDocument.buttons.forEach(function(pButton) {
          lToolbar.append(pButton);
        });
      }

      const lFocusElement = pDocument.widget.find('.focus-on-open');
      if (lFocusElement.length > 0) {
        lFocusElement.get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
        lFocusElement.removeClass('focus-on-open');
      }

      $('.ml_tree_document').trigger('document_opened', pDocument);
    });

    lEditor.on('close_all_documents', function() {
      resetEditor();

      lDocument.addClass('helper_text_editor_document');
      lDocument.append(getHelperText());
    });


    return lEditor;
  }

  function getHelperText() {
    if (environment.isOnUiBuilderPage()) { return $('<p id="ui_builder_backdrop_text"> Create an application under "Visual Sequence"<br/> to start creating an operator interface </p>'); }
    else if (environment.isOnConfigPage()) { return $('<p> Create a controller in the top bar to start editing the configuration. </p>'); }
    else if (environment.isOnMachineAppPage()) { return null; }
    else { return $('<p> Click "Add Application" to start creating a programming <br/> sequence to control your actuators, inputs and outputs </p>'); }
  }

  function playerWidget(pLibrary, isRobotReady = () => true) {
    const playerControlsContainer = $("<div>");
    const lRunTimeConfiguration = {};
    playerControlsContainer.setRunTimeConfiguration = function(pRunTimeConfiguration) {
      Object.assign(lRunTimeConfiguration, pRunTimeConfiguration);
    };

    let smallButtonSize = false;
    if(environment.isOnCad()){
      smallButtonSize = true;
    }

    const playerControls = <PlayerControls
      library={pLibrary}
      isRobotReady={isRobotReady}
      runTimeConfig={lRunTimeConfiguration}
      smallButtonSize={smallButtonSize}
    />;

    ReactDOM.render(playerControls, playerControlsContainer[0]);
    playerControlsContainer.markAsMachineLogicReactComponent("playerControls");

    return playerControlsContainer;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    checkboxWidget      : checkboxWidget,
    Document            : Document,
    documentContainer   : documentContainer,
    playerWidget        : playerWidget
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }

})();
